import { render, staticRenderFns } from "./ClubsListTable.vue?vue&type=template&id=8326c6b0&"
import script from "./ClubsListTable.vue?vue&type=script&lang=ts&"
export * from "./ClubsListTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ClubsListTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports